export const fonts = {
  default: "'HK Grotesk', 'Helvetica Neue', Helvetica, Arial, sans-serif",
  extended:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif",
}
